import { generateGUID } from "@/utils/guid";
import { FormSection } from "@psychlab/types/form"

export const duplicateFormSection = (section:FormSection):FormSection => {
	const copy = JSON.parse(JSON.stringify(section)) as FormSection;
	copy.id = generateGUID();
	copy.items.forEach(item => item.id = generateGUID());
	return copy;
};